import { PapiroConsole } from "src/utils/papiroConsole"

export function addCurrent(article) {
    return {
        type: 'ADD_CURRENT',
        article,
    }
}

export function addCurrentSearch(articlesearch, searchtype) {
    return {
        type: 'ADD_CURRENT_SEARCH',
        articlesearch,
        searchtype
    }
}
